import { useContext, useMemo } from "react";
import { Redirect, Route } from "react-router-dom";
import { GlobalContext } from "../../context/GlobalState";
import Navbar from "../Navbar/Navbar";
import { useLocation } from "react-router-dom";

const SecuredRoute = (props) => {
  const { userDetails } = useContext(GlobalContext);
  const location = useLocation();

  const hideNavbar = useMemo(() => {
    const isLessonPlan = location.pathname.startsWith("/lessonplans");
    const actionType = new URLSearchParams(location.search).get("action");
    return isLessonPlan && actionType === "download" ? true : false;
  }, [location]);

  return userDetails.isAuthenticated ? (
    <>
      {!hideNavbar ? <Navbar /> : null}
      <Route hideNavbar={hideNavbar} {...props} />
    </>
  ) : (
    <Redirect to={`/logout`} />
  );
};

export default SecuredRoute;
